export const CLASS_NAME = 'cst-page'
